var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v("Correo")]),_vm._v(" "),_c('h6',[_c('span',[_vm._v(" Correspondencia sin entregar: "+_vm._s(_vm.undeliveredMail)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }